import { mdiViewGrid } from '@mdi/js'
import Icon from '@mdi/react'
import { memo } from 'react'
import type { IconProps } from '.'

const Grid = memo((props: IconProps) => {
    const { filled, color, size = 1, title, ...other } = props
    return (
        <Icon
            path={mdiViewGrid}
            title={title}
            size={size}
            color={color}
            {...other}
        />
    )
})

export default Grid
